module.exports = __webpack_public_path__ + "static/media/ilustration-character-with-magnifying-glass.283fe411.svg";